<template>
	<div>
		<!-- <div class="section03_popup" v-if="typeof selectedAreaData.key !== 'undefined'"></div> -->
		
        <TrafficInfoWin v-show="false"
            v-on:loaded-traffic-info="loadedTrafficInfoHandle"
            ref="trafficInfoWin"></TrafficInfoWin>
            
	    <div class="map_legend" v-show="typeof selectedAreaData.key !== 'undefined' && !$_WC.isMobile">
		    <ul class="leg_tit">
                <li class="tit tit01 on">교통정보</li>
            </ul>
            <div class="leg_conts">
                <!-- 교통정보 -->
                <div class="content cont01 on">
                    <div class="leg_list">
                        <ul class="traffic01">
                            <li><span class="st01">원활</span></li>
                            <li><span class="st02">서행</span></li>
                            <li><span class="st03">지체</span></li>
                            <li><span class="st04">정체</span></li>
                            <li><span class="st05">정보없음</span></li>
                        </ul>
                    </div>
                </div>
            </div>
	    </div>
	</div>    
</template>
<script>
import naverMapShareMixins from '@/stores/naver.map.share.mixin';
import { $_TYPE, $_WC } from '@/confs/common.const.js';
import { mapGetters } from "vuex";
import TrafficInfoWin from "@/views/realtime/TrafficInfoWin.vue"; 

export default {
	components: {
        TrafficInfoWin,
    },
	data(){
		return {
			selectedAreaData: {},
			lineKey: 'road',
			colorMap: {
			    '원활': '#33DB87',
			    '서행': '#FFC033',
			    '정체': '#E34B63',
			},
		}
	},
	created(){
		this.$eventBus.$on("SeoulmapMapCtrl::loaded-seoulmap-data", (selectedAreaData) => {
		    this.selectedAreaData = selectedAreaData;
		});
	},
    watch: {
    	selectedAreaData: {
    	    immediate: false,
    	    handler(newVal, oldVal) {
    	        if(typeof newVal !== 'undefined') {
    	            this.showTrafficData();
    	        }  
    	    },
    	}
    },
    methods: {
        showTrafficData() {
            this.removePolyline(this.lineKey);
            if(typeof this.selectedAreaData.ROAD_TRAFFIC_STTS !== 'undefined') {
                let trafficList = this.selectedAreaData.ROAD_TRAFFIC_STTS;
                trafficList.forEach((d) => {
                    let color = '#C7C7C7';
                    if(typeof this.colorMap[d.IDX] !== 'undefined') {
                        color = this.colorMap[d.IDX];
                    }
                    let paths = [];
                    let xyList = d.XYLIST;
                    if(!!xyList) {
                        xyList = xyList.split('|');
                        xyList.forEach((data) => {
                            let path = data.split('_');
                            paths.push(path);
                        });
                    }
                    let strokeWeight = 5;
                    if($_WC.isMobile) {
                        strokeWeight = 3;
                    }
                    let geoJson = {features: [{type: 'Feature', properties: {key: d.DIST}, geometry: {coordinates: [[paths]]}}]};
                    this.makePolylineString(this.geoJsonKeyType.prop, 'key', geoJson, color, strokeWeight, 'solid', false, 0.6, function(key, event){
                        this.roadClickEvent(event, d);
                    }.bind(this), this.lineKey);
                    
                });
            }
        },
    	roadClickEvent(event, data){
    		let marker = new naver.maps.Marker({
                position: new naver.maps.LatLng(event.coord.y, event.coord.x),
                icon: {
                    url: $_WC.assets + 'img/marker2/marker_promise_A.png',
                    size: new naver.maps.Size(0, 0),
                }
            });
            
    		data.key = this.lineKey;
    		naver.maps.Event.addListener(marker, 'click', function(event) {
    			this.$store.dispatch('SET_SELECTED_MARKER', marker);
    			this.$refs.trafficInfoWin.setTrafficInfo(data);
    		}.bind(this));
    		marker.setMap(this.map);
    		
    		this.addMarkerMap('seoulmap', marker);
    		
    		naver.maps.Event.trigger(marker, 'click', null);
    	},
    	loadedTrafficInfoHandle: function(content){
    		this.openInfoWin(content);
    	},
    },
	mixins: [naverMapShareMixins],
};
</script>